import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type CatalogBrandsToolbarProps = {
  onCreate: () => void;
  canCreate: boolean;
};

export function CatalogBrandsToolbar({
  onCreate,
  canCreate,
}: CatalogBrandsToolbarProps) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">ຍີ່ຫໍ້ອາໄຫຼ່</h2>
        <p className="text-muted-foreground text-sm">ຈັດການຂໍ້ມູນແບຣນດ໌ (ຍີ່ຫໍ້ອາໄຫຼ່)</p>
      </div>
      {canCreate && (
        <Button onClick={onCreate}>
          <PlusIcon className="size-4" />
          ເພີ່ມແບຣນດ໌
        </Button>
      )}
    </div>
  );
}
